






















import { snakeCase } from 'lodash'
import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../../../Mixins/ModelSetter'
import { UseFields } from '../../../../Pi'
import { SelectOptionData } from '../../../../Pi/types'
import IncludeExcludeConditionMode from '../components/IncludeExcludeConditionMode.vue'
import { LabelsCondition } from '../types';

@Component({
  components: {
    IncludeExcludeConditionMode
  },
  data() {
    return {
      snakeCase
    }
  }
})
export default class DistributionLabelsCondition extends Mixins(UseFields, ModelSetter) {
  @VModel({ type: Object, required: true }) condition!: LabelsCondition

  @Prop() labelsOptions!: Array<SelectOptionData>

  @Prop({ type: Boolean, default: false }) disabled!: boolean
}
